export const SHOW_FADE_CARREGANDO = 'SHOW_FADE_CARREGANDO';
export const showFadeCarregando = (showCarregando) => ({
    type: SHOW_FADE_CARREGANDO,
    payload: {
        showCarregando: showCarregando
    }
});
export const PREENCHER_FILTRO_MACROSCOPIA = 'PREENCHER_FILTRO_MACROSCOPIA';
export const preencherFiltroMacroscopia = (filtros) => ({
    type: PREENCHER_FILTRO_MACROSCOPIA,
    payload: {
        filtros: filtros
    }
});
export const PREENCHER_FAVORITOS = 'PREENCHER_FAVORITOS';
export const preencherFavoritos = (favoritos) => ({
    type: PREENCHER_FAVORITOS,
    payload: {
        favoritos: favoritos
    }
});
export const PREENCHER_LISTAGEM_MACROSCOPIA = 'PREENCHER_LISTAGEM_MACROSCOPIA';
export const preencherListagemMacroscopia = (listagem) => ({
    type: PREENCHER_LISTAGEM_MACROSCOPIA,
    payload: {
        listagem: listagem
    }
});
export const PREENCHER_DETALHES = 'PREENCHER_DETALHES';
export const preencherDetalhes = (detalhes) => ({
    type: PREENCHER_DETALHES,
    payload: {
        detalhes: detalhes
    }
});
export const PREENCHER_FRASCOS = 'PREENCHER_FRASCOS';
export const preencherFrascos = (frascos) => ({
    type: PREENCHER_FRASCOS,
    payload: {
        frascos: frascos
    }
});
export const PREENCHER_SELECT_MATERIAL = 'PREENCHER_SELECT_MATERIAL';
export const preencherSelectMaterial = (material) => ({
    type: PREENCHER_SELECT_MATERIAL,
    payload: {
        material: material
    }
});
export const PREENCHER_SELECT_TIPO = 'PREENCHER_SELECT_TIPO';
export const preencherSelectTipo = (tipo) => ({
    type: PREENCHER_SELECT_TIPO,
    payload: {
        tipo: tipo
    }
});
export const PREENCHER_SELECT_MEDICO_TECNICO = 'PREENCHER_SELECT_MEDICO_TECNICO';
export const preencherSelectMedicoTecnico = (medico) => ({
    type: PREENCHER_SELECT_MEDICO_TECNICO,
    payload: {
        medicoTecnico: medico
    }
});
export const PREENCHER_SELECT_MEDICO_MACRO = 'PREENCHER_SELECT_MEDICO_MACRO';
export const preencherSelectMedicoMacro = (medico) => ({
    type: PREENCHER_SELECT_MEDICO_MACRO,
    payload: {
        medicoMacroscopista: medico
    }
});
export const ADICIONAR_BLOCO = 'ADICIONAR_BLOCO';
export const adicionarBloco = (blocos) => ({
    type: ADICIONAR_BLOCO,
    payload: {
        blocos: blocos
    }
});
export const ADICIONAR_BLOCOS_TEMPORARIOS = 'ADICIONAR_BLOCOS_TEMPORARIOS';
export const adicionarBlocosTemporarios = (blocos) => ({
    type: ADICIONAR_BLOCOS_TEMPORARIOS,
    payload: {
        blocosNovos: blocos
    }
});
export const ADICIONAR_BLOCOS_EXISTENTES = 'ADICIONAR_BLOCOS_EXISTENTES';
export const adicionarBlocosExistentes = (blocos) => ({
    type: ADICIONAR_BLOCOS_EXISTENTES,
    payload: {
        blocosExistentes: blocos
    }
});
export const PREENCHER_PROTOCOLO = 'PREENCHER_PROTOCOLO';
export const preencherProtocolo = (protocolo) => ({
    type: PREENCHER_PROTOCOLO,
    payload: {
        protocolo: protocolo
    }
});
export const PREENCHER_LAMINA_PROTOCOLO = 'PREENCHER_LAMINA_PROTOCOLO';
export const preenhcerLaminaProtocolo = (laminas) => ({
    type: PREENCHER_LAMINA_PROTOCOLO,
    payload: {
        laminas: laminas
    }
});
export const PREENCHER_CENTRO_RESPONSABILIDADE = 'PREENCHER_CENTRO_RESPONSABILIDADE';
export const preencherCentroResponsabilidade = (centroresponsabilidade) => ({
    type: PREENCHER_CENTRO_RESPONSABILIDADE,
    payload: {
        centroresponsabilidade: centroresponsabilidade
    }
});
export const PREENCHER_CESTAS = 'PREENCHER_CESTAS';
export const preencherCestas = (cestas) => ({
    type: PREENCHER_CESTAS,
    payload: {
        cestas: cestas
    }
});
export const DELEGAR_BLOCO_CESTA = 'DELEGAR_BLOCO_CESTA';
export const delegarBlocoParaCesta = (blocoCesta) => ({
    type: DELEGAR_BLOCO_CESTA,
    payload: {
        blocoCesta: blocoCesta
    }
});
export const PREENCHER_NAO_CONFORMIDADES = 'PREENCHER_NAO_CONFORMIDADES';
export const preenhcerNaoConformidades = (naoConformidades) => ({
    type: PREENCHER_NAO_CONFORMIDADES,
    payload: {
        naoConformidades: naoConformidades
    }
});
export const PREENCHER_HISTORICO_NAO_CONFORMIDADES = 'PREENCHER_HISTORICO_NAO_CONFORMIDADES';
export const preencherHistoricoNaoConformidades = (historicoNaoConformidades) => ({
    type: PREENCHER_HISTORICO_NAO_CONFORMIDADES,
    payload: {
        historicoNaoConformidades: historicoNaoConformidades
    }
});
export const PREENCHER_EXAMES_ABERTOS_MACRO = "PREENCHER_EXAMES_ABERTOS_MACRO";
export const preencherExamesEmAbertoMacroscopia = (examesAbertos) => ({
    type: PREENCHER_EXAMES_ABERTOS_MACRO,
    payload: {
        examesAbertos: examesAbertos
    }
});
export const ATUALIZAR_TEXTO_RTF = "ATUALIZAR_TEXTO_RTF";
export const atualizarTextoRtf = (rtf) => ({
    type: ATUALIZAR_TEXTO_RTF,
    payload: {
        rtf: rtf
    }
});
export const ARMAZENAR_TEXTO_LAUDO_RTF = "ARMAZENAR_TEXTO_LAUDO_RTF";
export const armazenarTextoLaudoRtf = (rtf) => ({
    type: ARMAZENAR_TEXTO_LAUDO_RTF,
    payload: {
        laudoExameRtf: rtf
    }
});
export const COLLAPSED_CONTAINER_EXAMES = "COLLAPSED_CONTAINER_EXAMES";
export const collapedContainerExames = (collapseContainerExames) => ({
    type: COLLAPSED_CONTAINER_EXAMES,
    payload: {
        collapseContainerExames: collapseContainerExames
    }
});
export const LISTAGEM_EXAMES_LAUDO = "LISTAGEM_EXAMES_LAUDO";
export const listagemExamensLaudo = (exames) => ({
    type: LISTAGEM_EXAMES_LAUDO,
    payload: {
        listagemExames: exames
    }
});
export const LISTAGEM_MEDICOS = "LISTAGEM_MEDICOS";
export const listagemMedicos = (medicos) => ({
    type: LISTAGEM_MEDICOS,
    payload: {
        medicos: medicos
    }
});
export const ARGUMENTOS_SALVAR_ETAPA_LAUDO = "ARGUMENTOS_SALVAR_ETAPA_LAUDO";
export const argumentosSalvarEtapaLaudo = (objeto) => ({
    type: ARGUMENTOS_SALVAR_ETAPA_LAUDO,
    payload: {
        laudarEtapaRequest: objeto
    }
});
export const ALTERAR_AUTOSAVE_TEXTO_LAUDO = "ALTERAR_AUTOSAVE_TEXTO_LAUDO";
export const alterarAutoSaveTextolaudo = (autosave) => ({
    type: ALTERAR_AUTOSAVE_TEXTO_LAUDO,
    payload: {
        autoSaveAtivo: autosave
    }
});
export const MACROSCOPIA_FINALIZADA = 'MACROSCOPIA_FINALIZADA';
export const macroscopiaFinalizada = (macroscopiaFinalizada) => ({
    type: MACROSCOPIA_FINALIZADA,
    payload: {
        macroscopiaFinalizada: macroscopiaFinalizada
    }
});
export const IMPRIMIR_CONTROLE_CASSETE_FINALIZAR_MAPA = 'IMPRIMIR_CONTROLE_CASSETE_FINALIZAR_MAPA';
export const imprimirControleCassetesAoFinalizarMapa = (imprimirControleCassetesAoFinalizarMapa) => ({
    type: IMPRIMIR_CONTROLE_CASSETE_FINALIZAR_MAPA,
    payload: {
        imprimirControleCassetesAoFinalizarMapa
    }
});
export const VISIBILIDADE_MODAL_MAPAMACROSCOPICO = 'VISIBILIDADE_MODAL_MAPAMACROSCOPICO';
export const visibilidadeModalMapaMacroscopico =
    (visibilidadeModalMapaMacroscopico) => ({
        type: VISIBILIDADE_MODAL_MAPAMACROSCOPICO,
        payload: {
            visibilidadeModalMapaMacroscopico
        }
    }
);


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/macroscopia/macroscopia.action.js